import styled, { css } from 'styled-components';
import Form from 'components/form';
import {
  NameEditor,
  DisabledName as _DisabledName,
} from 'routes/surface/components/node-modal-form/style';
import { ReactComponent as _CloseIcon } from 'styles/icons/close-icon.svg';
import { ReactComponent as _QuestionIcon } from 'styles/icons/question-icon.svg';
import { withModifiers } from 'utils/styles';
import { color } from 'styles/settings';

const iconStyle = css`
  width: 22px;
  height: 22px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  @media all and (min-width: 1200px) {
    margin: 0 60px;
  }
`;

export const DisabledName = styled(_DisabledName)`
  margin-top: 30px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 10px;
`;

export const NameTextInput = styled(NameEditor)`
  margin-top: 30px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 10px;
`;

export const QuestionInput = styled(Form.TextInput)`
  height: 60px;
`;

export const QuestionIcon = styled(_QuestionIcon)`
  ${iconStyle};
  margin-right: 12px;
`;

export const CloseIcon = styled(_CloseIcon)`
  ${iconStyle};
  cursor: pointer;
`;

export const QuestionnaireNodeWrapper = styled.div`
  margin: 46px auto 40px auto;
`;

export const AnswerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 60px 0;

  ${withModifiers('$invalid')`
      padding-bottom: 10px;
      margin-bottom: 15px;
      border: 1px solid ${color.ui.danger};
  `};
`;
